var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { SvgIcon } from "@material-ui/core";
const SvgDropdownLg = props => /*#__PURE__*/React.createElement(SvgIcon, _extends({
  viewBox: "0 0 21.879 13.033"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.356-6.85a.821.821,0,0,0,1.162,0L21.636-16.885a.821.821,0,0,0,0-1.162L20.282-19.4a.821.821,0,0,0-1.162,0l-8.183,8.1L2.755-19.4a.821.821,0,0,0-1.162,0L.239-18.047a.821.821,0,0,0,0,1.162Z",
  transform: "translate(0.002 19.642)"
})));
export default SvgDropdownLg;